import axios from "axios";
import { HOST_API_KEY } from "../../config";

import { axiosInstance } from "../utils/axios";

const registerNewUser = async (body) => {
  const response = await axios.post(`${HOST_API_KEY}/register`, body);
  return response;
};

const loginUser = async (body) => {
  const response = await axiosInstance.post(`${HOST_API_KEY}/login`, body);
  return response;
};

const startEmailLogin = async (body) => {
  const response = await axios.post(`/api/auth/email/start`, body);
  return response?.data;
};

const verifyEmailLogin = async (body) => {
  const response = await axios.post(`/api/auth/email/verify`, body);
  return response?.data;
};

const getCurrentAuthUser = async () => {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("jwtToken") : "";
  const response = await axiosInstance.get(`${HOST_API_KEY}/auth/me`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return response?.data;
};

const forgotPassword = async (email) => {
  const request = await axios.post(`${HOST_API_KEY}/forgot-password`, {
    email,
  });
  return request?.data;
};

const resetPassword = async (body) => {
  const request = await axios.post(`${HOST_API_KEY}/reset-password`, body);
  return request?.data;
};

const verifyForgotPasswordToken = async (body) => {
  const request = await axios.post(
    `${HOST_API_KEY}/verify-forgot-password-token`,
    body
  );
  return request?.data;
};

export {
  registerNewUser,
  loginUser,
  startEmailLogin,
  verifyEmailLogin,
  getCurrentAuthUser,
  forgotPassword,
  resetPassword,
  verifyForgotPasswordToken,
};
